import { render, staticRenderFns } from "./DescriptionServices.vue?vue&type=template&id=13c73c86"
import script from "./DescriptionServices.vue?vue&type=script&lang=js"
export * from "./DescriptionServices.vue?vue&type=script&lang=js"
import style0 from "./DescriptionServices.vue?vue&type=style&index=0&id=13c73c86&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c73c86')) {
      api.createRecord('13c73c86', component.options)
    } else {
      api.reload('13c73c86', component.options)
    }
    module.hot.accept("./DescriptionServices.vue?vue&type=template&id=13c73c86", function () {
      api.rerender('13c73c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DescriptionServices.vue"
export default component.exports